module.exports = __webpack_public_path__ + "static/media/40-5.db4be893.mp3";